/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Collection } from './collection';


export interface CollectionResultResponse { 
    /**
     * the total number of results
     */
    count: number;
    result: Array<Collection>;
}

